import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { CSVLink } from "react-csv";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation } from "react-i18next";

const ExportCSVModal = (  { show, onCloseClick, data, t} ) =>
{
  return (
    <Modal isOpen={ show } toggle={ onCloseClick } centered={ true }>
      <ModalHeader toggle={ onCloseClick }></ModalHeader>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/nocovwne.json"
            trigger="loop"
            colors="primary:#014c94,secondary:#eac22f"
            style={ { width: "100px", height: "100px" } }
          >
          </lord-icon>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            {/* <h4>Are you sure ?</h4> */ }
            <h4>{ t( "Are you sure ?" ) }</h4>
            <p className="text-muted mx-4 mb-0">
              { t( "Are you sure you want to export CSV file ?" ) }
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={ onCloseClick }
          >
            {t('Close')}
          </button>
          <CSVLink
            data={ data }
            type="button"
            onClick={ onCloseClick }
            className="btn w-sm"
            color="#014c94"
            id="delete-record"
          >
            {t('Download')}
          </CSVLink>
        </div>
      </ModalBody>
    </Modal>
  );
};

ExportCSVModal.propTypes = {
  onCloseClick: PropTypes.func,
  data: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.func,
};

export default withTranslation()( ExportCSVModal );